import React, { Component } from "react";
import client from "@culturehq/client";
import { Loader } from "@culturehq/components";

import { errorService } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";

import SurveyItem from "./SurveyItem";

class SurveyItems extends Component {
  state = {
    previousResponses: {},
    currentResponses: {},
    loading: false,
    error: null
  };

  componentDidMount() {
    this.componentIsMounted = true;
  }

  componentWillUnmount() {
    this.componentIsMounted = false;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const previousResponses = {};

    nextProps.submittedResponses.forEach(submittedResponse => {
      previousResponses[submittedResponse.surveyItemId] = submittedResponse;
    });

    if (previousResponses !== prevState.previousResponses) {
      return { previousResponses };
    }
    return null;
  }

  getSubmitDisabled = () => {
    const { currentResponses } = this.state;
    const { survey: { ratingItemId } } = this.props;

    if (ratingItemId) {
      return !currentResponses[ratingItemId];
    }

    return !Object.keys(currentResponses).some(surveyItemId => {
      const response = currentResponses[surveyItemId];
      const { surveyItemResponseOptionIds } = response;

      return response.body || (surveyItemResponseOptionIds && surveyItemResponseOptionIds.length);
    });
  };

  handleSubmit = async () => {
    const { onSurveyComplete, survey } = this.props;
    const { currentResponses, previousResponses } = this.state;

    this.setState({ loading: true, error: null });

    const promises = (
      Object.keys(currentResponses).map(surveyItemId => {
        const currentResponse = currentResponses[surveyItemId];

        if (previousResponses[surveyItemId]) {
          return client.updateSurveyUserItemResponse(currentResponse);
        }
        return client.createSurveyUserItemResponse(currentResponse);
      })
    );

    try {
      await Promise.all(promises);

      if (this.componentIsMounted) {
        this.setState({ loading: false });
      }
      onSurveyComplete(survey);
    } catch (error) {
      errorService.error(error);

      if (this.componentIsMounted) {
        this.setState({ error, loading: false });
      }
    }
  };

  handleChange = response => {
    this.setState(({ currentResponses }) => ({
      currentResponses: {
        ...currentResponses,
        [response.surveyItemId]: response
      }
    }));
  };

  render() {
    const { loading, error, previousResponses } = this.state;
    const { survey: { surveyItems } } = this.props;

    return (
      <div className="clearfix">
        <div className="col-sm-12">
          <Loader loading={loading}>
            {surveyItems.map((surveyItem, index) => (
              <SurveyItem
                key={surveyItem.id}
                itemNumber={index + 1}
                surveyItem={surveyItem}
                submittedResponse={previousResponses[surveyItem.id]}
                onChange={this.handleChange}
              />
            ))}

            <div className="row">
              <div className="col-sm-12">
                {error && <ErrorMessage error={error} />}
              </div>
              <div className="col-sm-12">
                <button
                  type="button"
                  className="button btn submit"
                  onClick={this.handleSubmit}
                  disabled={this.getSubmitDisabled()}
                >
                  {loading ? "Loading..." : "Submit"}
                </button>
              </div>
              <div className="col-sm-12">
                <p className="info">
                  <i>Note: Your responses are completely anonymous</i>
                </p>
              </div>
            </div>
          </Loader>
        </div>
      </div>
    );
  }
}

export default SurveyItems;
